// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Infrastructure
import { ProjectAPI } from "../../../../../api/application/Projects";
import { IntentsAPI } from "views/Bots/NLP/application/Build/Tabs/Intents/infrastructure";
import { IntegrationsAPI } from "api/application/Integrations";
import { get_users } from "api/application/Users";

import Integrations from "views/Bots/NLP/application/Build/Tabs/Intents/application/Integrations";

// Vendor
import { showNotify } from "vendor/application/disptach";
import {
  addArtifact,
  inactivityBody,
  inactivityMessagesBody,
  isValidDate,
} from "vendor/application";
// Material
import { Chip, CircularProgress, Divider, Switch } from "@material-ui/core";
import {
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Alert from "@material-ui/lab/Alert";
// Components
import CardEmpty from "components/Card/CardEmpty";
import { Button, Input } from "@components/Input";
import Select from "components/Input/select";
import FloatButtons from "components/Input/float_buttons";
import {ElementsCustom} from "@components/Elements";
// Translations
import { withTranslation } from "react-i18next";
// SVG
import { closeSvg, svgClock } from "assets";
import { DEFAULT_TTL, defaultTtl } from "utils/defaultTtl";

class ChatbotInactivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inactivity: {},
      new_inactivity: false,
      intents: [],
      desk_true: [],
      selectable_intents: [],
      lang_codes: [],
      all_lang_codes: [],
      selectedDate: "",
      ttl: { active: false, ttl_time: DEFAULT_TTL, intents: [] },
      new_ttl: false,
      intents_ttl: [],
      desk_true_ttl: [],
      desk_false_ttl: [],
      selectable_intents_ttl: [],
      selectedDate_ttl: "",
      ttl_diff: { active: false, ttl_time: DEFAULT_TTL, intents: [] },
      intents_ttl_diff: [],
      selectable_intents_ttl_diff: [],
      selectedDate_ttl_diff: "",
      integrations: [],
      zendesk_groups: false,
      switchboard: { updated: false, array: [] },
      use_custom_fields: false,
      localIntent: {
        desks: null
      }
    };
  }

  componentDidMount = () => {
    this.init();
    this.getIntegrations().then(() => {
      const { localIntent } = this.state;
      if (localIntent.desks?.info?.desk_id && this.state.integrations.length > 0) 
      {
        this.getGroups(localIntent.desks.info.desk_id);
      }
    });
  };

  componentDidUpdate = (nextProps) => {
    if (nextProps.data.actualProject.id !== this.props.data.actualProject.id) {
      this.init();
    }
  };

  init = () => {
    this.getIntentsDesk();
    this.getCodes();
  };

  getIntentsDesk = async () => {
    const { access, actualProject } = this.props.data;
    try {
      const obj = new IntentsAPI(actualProject.id, access, this.props);
      const desk = await obj.get_intents_desk();

      desk.desk_true.forEach((el) => {
        el.desk = true;
      });
      desk.desk_false.forEach((el) => {
        el.desk = false;
      });
      this.setState({
        desk_true: desk.desk_true,
        desk_false: desk.desk_false,
      });

      // Initialize the intent pool for the differential TTL section
      const allIntents = [...desk.desk_true, ...desk.desk_false];
      this.setState({ selectable_intents_ttl_diff: allIntents });

      this.getInactivity();
    } catch (err) {
      var data = { message: err, severity: "error" };
      this.props.dispatch(showNotify(data));
    }
  };

  getIntegrations = async () => {
    const { access, actualProject, limitsIntegrations } = this.props.data;
    try {
      const obj = new IntegrationsAPI(actualProject.id, access, this.props);
      const res = await obj.get_integrations();
      const allowedChannels = ["zendesk_full", "sunco"];
      const zendeskFull = res.filter(integration =>allowedChannels.includes(integration.channel));

      const integrations = this.processIntegrations(zendeskFull, limitsIntegrations);
      await this.processSpecialIntegrations(integrations);
      this.setState({ integrations });
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  processIntegrations = (integrations, limitsIntegrations) => {
    const processed = [];
    
    integrations.forEach((integration) => {
      const exist = processed.filter(int => int.channel === integration.channel);
      
      if ([
        "zendesk_full",
        "zendesk_chat",
        "centridesk",
        "sunco",
        "gpt-3"
      ].includes(integration.channel) && exist.length <= 0) {
        
        if (limitsIntegrations[integration.channel]?.multiple) {
          const multiple = integrations.filter(int => int.channel === integration.channel);
          if (multiple.length > 0) {
            integration.multiple = multiple.map(m => ({
              id: m.id,
              name: m.name ?? m.channel,
              use_custom_fields: m.info.use_custom_fields,
            }));
          }
        }
        processed.push(integration);
      }
    });
    
    return processed;
  };

  processSpecialIntegrations = async (integrations) => {
    // Sunco
    const sunco = integrations.find(i => i.channel === "sunco");
    if (sunco?.active && sunco?.info?.switchboard.updated) {
      await this.getSwitchboard(sunco);
    }

    // Centridesk
    const centridesk = integrations.find(i => i.channel === "centridesk");
    if (centridesk) {
      await this.getUsers();
    }
  };

  getSwitchboard = async (sunco) => {
    const { actualProject, access } = this.props.data;
    try {
      const obj = new IntegrationsAPI(actualProject.id, access, this.props);
      const res = await obj.get_integration_switchboard_by_id(sunco.id);
      this.setState({ switchboard: { updated: true, array: res } });
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  getGroups = async (channel_id) => {
    const { access, actualProject } = this.props.data;
    try {
      const obj = new IntegrationsAPI(actualProject.id, access, this.props);
      const res = await obj.get_zendesk_groups(channel_id);
      this.setState({ zendesk_groups: res });
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  getUsers = async () => {
    try {
      const users = await get_users(this.props);
      this.setState({ users });
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  /**
   * Fetches inactivity and TTL data from the service and updates the component's state accordingly.
   *
   * Note: At the moment, the backend returns `ttl.intents` as an array of objects
   * (e.g., [{ intent_id, created_at }]). Here, we transform this structure to extract only
   * the `intent_id` values, simplifying its consumption in the frontend.
   *
   * This transformation ensures forward compatibility in case the backend later returns
   * a simpler structure—an array of strings. With this adjustment, the frontend remains
   * resilient to either response format.
   *
   * If the inactivity or TTL data is missing, default values are initialized and the
   * corresponding handlers are triggered.
   * Any errors during the request are caught and dispatched via notification.
   */

  getInactivity = async () => {
    const { access, actualProject } = this.props.data;
    try {
      const obj = new ProjectAPI(actualProject.id, access, this.props);
      const data = await obj.get_inactivity();

      if (!data.inactivity.messages) {
        this.setState({ inactivity: false, new_inactivity: true, localIntent: { desks: null } });
        this.handleDate();
      } else {
        const { inactivity } = data;
        let deskInfo = inactivity.desk_info;
        this.setState({
          inactivity: {
            ...inactivity,
            desk_info: deskInfo,
            desk_assign: inactivity.desk_assign ?? false,
            desk_tickets: inactivity.desk_tickets ?? false,
          },
          localIntent: {desks: deskInfo}
        });
        this.handleDate(inactivity);
        this.handleIntents();
        if (inactivity.desk_info?.info?.desk_id && this.state.integrations.length > 0)
        {
          this.getGroups(inactivity.desk_info.info.desk_id);
        }
      }
      if (!data.ttl) {
        const defaultTtlObj = { active: false, ttl_time: DEFAULT_TTL, intents: [] };
        this.setState({ ttl: defaultTtlObj, new_ttl: true });
        this.handleDateTtl(defaultTtlObj);
        this.handleDateTtlSpecific(defaultTtlObj, "diff");
      } else {
        const ttl = {
          ...data.ttl,
          intents: (data.ttl.intents || []).map((iInt) => iInt.intent_id || iInt),
          ttl_time: defaultTtl(data.ttl.ttl_time),
        };
        this.setState({ ttl });
        this.handleDateTtl(ttl);
        this.handleIntentsTtl();

        const rawTtlDiff = data.ttl.ttl_diff || {};
        const ttl_diff = {
          active: !!rawTtlDiff.active,
          ttl_time: defaultTtl(rawTtlDiff.ttl_time),
          intents: (rawTtlDiff.intents || []).map((iInt) => iInt.intent_id || iInt),
        };
        this.setState({ ttl_diff });
        this.handleDateTtlSpecific(ttl_diff, "diff");
        this.handleIntentsTtlSpecific(ttl_diff, "diff");
      }
    } catch (err) {
      var data = { message: err, severity: "error" };
      this.props.dispatch(showNotify(data));
    }
  };

  getCodes = async () => {
    const { access, actualProject } = this.props.data;
    try {
      const obj = new ProjectAPI(actualProject.id, access, this.props);
      const codes = await obj.get_codes();

      this.setState({
        lang_codes: codes,
        all_lang_codes: JSON.parse(JSON.stringify(codes)),
      });
    } catch (err) {
      var data = { message: err, severity: "error" };
      this.props.dispatch(showNotify(data));
    }
  };

  handleDate = (inactivity) => {
    if (inactivity) {
      var time = inactivity.inactivity_time,
        split = time.split(":"),
        h = split[0],
        m = split[1],
        s = split[2];

      this.setState({ selectedDate: new Date(new Date().setHours(h, m, s)) });
    } else {
      this.setState({ selectedDate: new Date(new Date().setHours(0, 1, 0)) });
    }
  };

  handleDateTtl = (ttl) => {
    const time = defaultTtl(ttl?.ttl_time || DEFAULT_TTL);
    const [h, m, s] = time.split(":");
    this.setState({
      selectedDate_ttl: new Date(new Date().setHours(h, m, s)),
    });
  };

  handleDateTtlSpecific = (ttlSpecific, ttlType) => {
    const time = defaultTtl(ttlSpecific?.ttl_time || DEFAULT_TTL);
    const [h, m, s] = time.split(":");
    const dateKey = ttlType === "diff" ? "selectedDate_ttl_diff" : `selectedDate_ttl_${ttlType}`;
    this.setState({ [dateKey]: new Date(new Date().setHours(h, m, s)) });
  };

  handleIntents = () => {
    const { desk_true, desk_false, inactivity, intents, lang_codes } =
      this.state;

    inactivity.intents.forEach((intent) => {
      desk_true.forEach((dTrue) => {
        if (dTrue.id === intent) {
          intents.push(dTrue);
        }
      });

      desk_false.forEach((dFalse) => {
        if (dFalse.id === intent) {
          intents.push(dFalse);
        }
      });
    });

    inactivity.messages.forEach((message) => {
      lang_codes.forEach((lang, i) => {
        if (message.lang === lang) {
          lang_codes.splice(i, 1);
          i--;
        }
      });
    });

    var arr = desk_false.filter(this.comparer(intents));
    this.setState({
      selectable_intents_ttl: intents,
      selectable_intents: arr,
      intents,
      lang_codes,
    });
  };

  handleIntentsTtl = () => {
    const { ttl, intents_ttl, selectable_intents_ttl } = this.state;
    const new_intents_ttl = [...intents_ttl];
    let new_selectable_intents_ttl = [...selectable_intents_ttl];
    ttl.intents.forEach((intent) => {
      selectable_intents_ttl.forEach((dTrue) => {
        if (dTrue.id === intent) {
          new_intents_ttl.push(dTrue);
          new_selectable_intents_ttl = new_selectable_intents_ttl.filter(
            (i) => i.id !== intent
          );
        }
      });
    });

    this.setState({
      intents_ttl: new_intents_ttl,
      selectable_intents_ttl: new_selectable_intents_ttl,
    });
  };

  handleIntentsTtlSpecific = (ttlSpecific, ttlType) => {
    const { desk_true, desk_false } = this.state;
    const allIntents = [...desk_true, ...desk_false];
    const intentsKey = ttlType === "diff" ? "intents_ttl_diff" : `intents_ttl_${ttlType}`;
    const selectableKey = ttlType === "diff" ? "selectable_intents_ttl_diff" : `selectable_intents_ttl_${ttlType}`;

    const selectedIntents = [];
    const selectableIntents = allIntents.filter((intent) => {
      const isSelected = (ttlSpecific.intents || []).includes(intent.id);
      if (isSelected) selectedIntents.push(intent);
      return !isSelected;
    });

    this.setState({
      [intentsKey]: selectedIntents,
      [selectableKey]: selectableIntents,
    });
  };

  comparer(otherArray) {
    return function (current) {
      return (
        otherArray.filter(function (other) {
          return other.id === current.id;
        }).length === 0
      );
    };
  }

  handleTimePicker = (e) => {
    const { inactivity } = this.state;
    if (isValidDate(e)) {
      const h = e.getHours();
      const m = e.getMinutes();
      const s = e.getSeconds();
      let d = `${h.toString().length === 1 ? `0${h}` : h}:${m.toString().length === 1 ? `0${m}` : m
        }:${s.toString().length === 1 ? `0${s}` : s}`;

      if (h === 0 && m < 1) {
        e = new Date(new Date().setHours(0, 1, 0));
        d = "00:01:00";
      }
      inactivity.inactivity_time = d;
      this.setState({ selectedDate: e });
    }
  };
  handleTimePickerTtl = (e) => {
    const { ttl } = this.state;
    if (isValidDate(e)) {
      const h = e.getHours();
      const m = e.getMinutes();
      const s = e.getSeconds();
      let d = `${h.toString().length === 1 ? `0${h}` : h}:${m.toString().length === 1 ? `0${m}` : m
        }:${s.toString().length === 1 ? `0${s}` : s}`;
      if (h === 0 && m < 1) {
        e = new Date(new Date().setHours(0, 1, 0));
        d = "00:01:00";
      }
      ttl.ttl_time = d;
      this.setState({ selectedDate_ttl: e });
    }
  };

  handleTimePickerTtlSpecific = (e, ttlType) => {
    const ttlKey = ttlType === "diff" ? "ttl_diff" : `ttl_${ttlType}`;
    const dateKey = ttlType === "diff" ? "selectedDate_ttl_diff" : `selectedDate_ttl_${ttlType}`;
    const ttlSpecific = { ...this.state[ttlKey] };
    if (isValidDate(e)) {
      const h = e.getHours();
      const m = e.getMinutes();
      const s = e.getSeconds();
      let d = `${h.toString().length === 1 ? `0${h}` : h}:${m.toString().length === 1 ? `0${m}` : m
        }:${s.toString().length === 1 ? `0${s}` : s}`;
      if (h === 0 && m < 1) {
        e = new Date(new Date().setHours(0, 1, 0));
        d = "00:01:00";
      }
      ttlSpecific.ttl_time = d;
      this.setState({ [ttlKey]: ttlSpecific, [dateKey]: e });
    }
  };

  handleToggleTtlSpecificActive = (e, ttlType) => {
    const ttlKey = ttlType === "diff" ? "ttl_diff" : `ttl_${ttlType}`;
    const ttlSpecific = { ...this.state[ttlKey] };
    ttlSpecific.active = !ttlSpecific.active;
    this.setState({ [ttlKey]: ttlSpecific });
  };

  selectIntentDeskTtlSpecific = (intentId, ttlType) => {
    const ttlKey = ttlType === "diff" ? "ttl_diff" : `ttl_${ttlType}`;
    const intentsKey = ttlType === "diff" ? "intents_ttl_diff" : `intents_ttl_${ttlType}`;
    const selectableKey = ttlType === "diff" ? "selectable_intents_ttl_diff" : `selectable_intents_ttl_${ttlType}`;

    const ttlSpecific = { ...this.state[ttlKey] };
    const selectedIntents = [...this.state[intentsKey]];
    const selectableIntents = [...this.state[selectableKey]];

    const intentIndex = selectableIntents.findIndex((el) => el.id === intentId);
    if (intentIndex !== -1) {
      selectedIntents.push(selectableIntents[intentIndex]);
      selectableIntents.splice(intentIndex, 1);
    }

    ttlSpecific.intents = [...ttlSpecific.intents, intentId];
    this.setState({ [ttlKey]: ttlSpecific, [intentsKey]: selectedIntents, [selectableKey]: selectableIntents });
  };

  handleDeleteIntentTtlSpecific = (e, intent, iteration, ttlType) => {
    const ttlKey = ttlType === "diff" ? "ttl_diff" : `ttl_${ttlType}`;
    const intentsKey = ttlType === "diff" ? "intents_ttl_diff" : `intents_ttl_${ttlType}`;
    const selectableKey = ttlType === "diff" ? "selectable_intents_ttl_diff" : `selectable_intents_ttl_${ttlType}`;

    const ttlSpecific = { ...this.state[ttlKey] };
    const selectedIntents = [...this.state[intentsKey]];
    const selectableIntents = [...this.state[selectableKey]];

    selectedIntents.forEach((el, i) => {
      if (el.id === intent.id) {
        selectedIntents.splice(i, 1);
        selectableIntents.push(el);
      }
    });

    ttlSpecific.intents = ttlSpecific.intents.filter((id) => id !== intent.id);
    this.setState({ [ttlKey]: ttlSpecific, [intentsKey]: selectedIntents, [selectableKey]: selectableIntents });
  };

  addInactivity = () => {
    const { lang_codes } = this.state;
    var inactivity = inactivityBody(this.props.project_lang);

    lang_codes.forEach((el, i) => {
      if (el === inactivity.default_lang) {
        lang_codes.splice(i, 1);
      }
    });

    this.setState({
      inactivity: inactivity,
      lang_codes: lang_codes,
      selectable_intents: this.state.desk_false,
      new_inactivity: true,
    });
  };

  updateInactivity = async (e) => {
    e.preventDefault();
    const { inactivity, new_inactivity, ttl, ttl_diff } = this.state;
    const { access, actualProject } = this.props.data;
    const payloadTtl = {
      ...ttl,
      ttl_time: defaultTtl(ttl?.ttl_time),
      ttl_diff: { ...ttl_diff, ttl_time: defaultTtl(ttl_diff?.ttl_time) },
    };

    try {
      const obj = new ProjectAPI(actualProject.id, access, this.props, {
        inactivity,
        ttl: payloadTtl,
      });
      await obj.do_inactivity(new_inactivity ? "POST" : "PUT");

      this.props.dispatch(
        showNotify({
          message: "inactivities",
          type: new_inactivity ? "create" : "edit",
          severity: "success",
        })
      );

      this.setState({ new_inactivity: false });
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  handleIntegrationChange = (updatedIntent) => {
    this.setState(prevState => {
      const newInactivity = { 
        ...prevState.inactivity,
        desk_info: updatedIntent.desks
      };
      
      if (!updatedIntent.desks?.name) {newInactivity.desk_tickets = false;}
      return {
        localIntent: updatedIntent,
        inactivity: newInactivity
      };
    });
  };

  // update element state
  updateElement = (e, variable, type, i) => {
    e.preventDefault();
    const { inactivity } = this.state;

    if (type && type !== "boolean") {
      inactivity[variable][i][type] = e.target.value;
    } else if (type === "boolean") {
      inactivity[variable] = !inactivity[variable];
    } else if (type === "object") {
      inactivity.desk_info = {
        ...inactivity.desk_info,
        [type]: e.target.value
      };
    } else {
      inactivity[variable] = e.target.value;
    }

    this.setState({ inactivity: inactivity });
  };

  updateElementTtl = (e, variable, type, i) => {
    e.preventDefault();
    const { ttl } = this.state;

    if (type && type !== "boolean") {
      ttl[variable][i][type] = e.target.value;
    } else if (type === "boolean") {
      ttl[variable] = !ttl[variable];
    } else {
      ttl[variable] = e.target.value;
    }
    this.setState({ ttl });
  };

   handleToggleTtlActive = (e) => {
    const { ttl } = this.state;
    if (ttl?.active) {
      this.props.dispatch(
        showNotify({
          message:
           "ttl_disable",
          severity: "error",
        })
      );
    }
    this.updateElementTtl(e, "active", "boolean");
  };

  selectIntentDesk = (e) => {
    const { intents, inactivity, selectable_intents, selectable_intents_ttl } =
      this.state;
    const newIntentTtl = [...selectable_intents_ttl];

    selectable_intents.forEach((el, i) => {
      if (el.id === e) {
        intents.push(el);
        newIntentTtl.push(el);
        selectable_intents.splice(i, 1);
      }
    });

    inactivity.intents.push(e);

    this.setState({
      selectable_intents,
      intents,
      inactivity,
      selectable_intents_ttl: newIntentTtl,
    });
  };

  selectIntentDeskTtl = (e) => {
    const { intents_ttl, ttl, selectable_intents_ttl, intents } = this.state;
    const newIntent = [...selectable_intents_ttl];
    selectable_intents_ttl.forEach((el, i) => {
      if (el.id === e) {
        intents_ttl.push(el);
        newIntent.splice(i, 1);
      }
    });

    ttl.intents.push(e);

    this.setState({
      intents_ttl,
      selectable_intents_ttl: newIntent,
      intents,
      ttl,
    });
  };

  handleDeleteIntent = (e, intent, iteration) => {
    const {
      intents,
      inactivity,
      ttl,
      selectable_intents,
      selectable_intents_ttl,
      intents_ttl,
    } = this.state;
    let newSelectable_intents_ttl = [...selectable_intents_ttl];
    let newIntents_ttl = [...intents_ttl];
    intents.forEach((el) => {
      if (el.id === intent.id) {
        intents.splice(iteration, 1);
        newIntents_ttl = newIntents_ttl.filter((i) => i.id !== intent.id);
        newSelectable_intents_ttl = newSelectable_intents_ttl.filter(
          (i) => i.id !== intent.id
        );
        selectable_intents.push(el);
      }
    });


    this.setState({
      selectable_intents,
      intents,
      inactivity: {
        ...inactivity,
        intents: intents.map((i) => i.id),
      },
      intents_ttl: newIntents_ttl,
      ttl: { ...ttl, intents: newIntents_ttl.map((i) => i.id) },
      selectable_intents_ttl: newSelectable_intents_ttl,
    });
  };
  handleDeleteIntentTtl = (e, intent, iteration) => {
    const { intents_ttl, ttl, selectable_intents_ttl } = this.state;

    intents_ttl.forEach((el) => {
      if (el.id === intent.id) {
        intents_ttl.splice(iteration, 1);
        selectable_intents_ttl.push(el);
      }
    });

    ttl.intents.forEach((el, i) => {
      if (el === intent.id) {
        ttl.intents.splice(i, 1);
      }
    });

    this.setState({
      intents_ttl,
      ttl,
      selectable_intents_ttl,
    });
  };

  addMessage = (e) => {
    const { inactivity, lang_codes } = this.state;

    var a = false;
    inactivity.messages.forEach((el) => {
      if (el.lang === e) {
        a = true;
      }
    });

    if (!a) {
      inactivity.messages.push(inactivityMessagesBody(e));
      lang_codes.forEach((el, i) => {
        if (el === e) {
          lang_codes.splice(i, 1);
        }
      });

      this.setState({ inactivity: inactivity, lang_codes: lang_codes });
    }
  };

  deleteMessage = (e, lang, i) => {
    const { inactivity, lang_codes } = this.state;

    lang_codes.push(lang);
    inactivity.messages.splice(i, 1);

    this.setState({ inactivity: inactivity, lang_codes: lang_codes });
  };

  selectDefaultLang = (e) => {
    const { inactivity } = this.state;
    inactivity.default_lang = e;

    this.setState({ inactivity: inactivity });
    this.addMessage(e);
  };

  handleArtifacts = (e, i, artifact_type, type) => {
    const { inactivity } = this.state;

    var res = addArtifact(i, artifact_type, type, inactivity);

    this.setState({ inactivity: res });
  };

  handleTags = (e, type, elementType, chipToDelete, i) => {
    const { inactivity } = this.state;
    const newInactivity = { ...inactivity };

    switch (type) {
      case 'add':
        newInactivity.input = e.target.value;
        break;
      case 'delete':
        newInactivity.desk_tags.splice(i, 1);
        break;
      case 'enter':
        if (e.target.value.trim() !== '') {
          if (!newInactivity.desk_tags) {
            newInactivity.desk_tags = [];
          }
          newInactivity.desk_tags.push(e.target.value.trim());
          newInactivity.input = '';
        }
        break;
    }

    this.setState({ inactivity: newInactivity });
  };

  renderHeader = () => {
    const { t } = this.props;
    const { isSending } = this.props.data;

    return (
      <div className={"header"}>
        <div className={"header_content spacing_title"}>
          <div className={"header_title"}>
            <span className={"title"}>
              {t("card.content.project.inactivity.title")}
            </span>
            <span className={"description"}>
              {t("card.content.project.inactivity.description")}
            </span>
          </div>
        </div>
        <div className={"header_actions"}>
          {isSending ? (
            <Button type={"primary"} text={<CircularProgress size={21} />} />
          ) : (
            <Button
              type={"primary"}
              onClick={(e) => this.updateInactivity(e)}
              text={t("card.content.project.inactivity.button_save")}
            />
          )}
        </div>
      </div>
    );
  };

  renderInactivitySection = () => {
    const { t } = this.props;
    const {
      inactivity,
      selectedDate,
      selectable_intents,
      intents,
      all_lang_codes,
      lang_codes,
      integrations,
      zendesk_groups,
      switchboard,
      localIntent
    } = this.state;
    return (
      <div className={"content"}>
        <div className={"elements__main"}>
          <div className={"elements__picker"}>
            <div>
              <div>
                <span>{t("card.content.project.inactivity.switch")}</span>
              </div>
              <Switch
                checked={inactivity.active}
                onClick={(e) => {
                  this.updateElement(e, "active", "boolean");
                }}
                color="primary"
              />
            </div>
          </div>
          <Divider />
          <div className={"elements__picker"}>
            <div>
              <div>
                <span>{t("card.content.project.inactivity.time.title")}</span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t(
                      "card.content.project.inactivity.time.description"
                    ),
                  }}
                ></span>
              </div>
              {selectedDate && (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    className={"input-primary"}
                    ampm={false}
                    openTo="minutes"
                    views={["hours", "minutes", "seconds"]}
                    format="HH:mm:ss"
                    value={selectedDate}
                    onChange={(e) => this.handleTimePicker(e)}
                    keyboardIcon={svgClock()}
                  />
                </MuiPickersUtilsProvider>
              )}
            </div>
          </div>
          <Divider />
          <div>
            <div className={"elements__grid"}>
              <div className={"elements__title"}>
                <span>
                  {t("card.content.project.inactivity.default_lang.title")}
                </span>
                <span>
                  {t(
                    "card.content.project.inactivity.default_lang.description"
                  )}
                </span>
              </div>
              {/* default_lang */}
              {all_lang_codes && (
                <div className={"elements_codes"}>
                  <Select
                    strSelected={t(
                      `languages:languages.${inactivity.default_lang}`
                    )}
                    placeholder={t(
                      "card.content.project.inactivity.default_lang.select_placeholder"
                    )}
                    array={all_lang_codes}
                    onSelect={this.selectDefaultLang}
                    id={"code-language"}
                    type={"code_language"}
                    t={t}
                  />
                </div>
              )}
            </div>
          </div>
          <Divider />
          <div>
            <div className={"elements__grid"}>
              <div className={"elements__title"}>
                <span>
                  {t("card.content.project.inactivity.messages.title")}
                </span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t(
                      "card.content.project.inactivity.messages.description"
                    ),
                  }}
                ></span>
              </div>
              <div className={"elements_codes"}>
                <Select
                  strSelected={t(
                    "card.content.project.inactivity.messages.select_placeholder"
                  )}
                  placeholder={t(
                    "card.content.project.inactivity.messages.select_placeholder"
                  )}
                  array={lang_codes}
                  onSelect={this.addMessage}
                  id={"code-language"}
                  type={"code_language"}
                  t={t}
                />
              </div>
              <div className={"pd-0"}>
                <div className={"elements__grid"}>
                  {inactivity.messages.length > 0 ? (
                    inactivity.messages.map((message, i) => {
                      return (
                        <div key={i} className={"elements__inactivity"}>
                          <div className={"elements__lang"}>{message.lang}</div>
                          <Input
                            value={message.response}
                            type={"primary"}
                            multiline
                            inputProps={{ maxLength: 2000 }}
                            placeholder={t(
                              "card.content.project.inactivity.messages.card.placeholder"
                            )}
                            onChange={(e) =>
                              this.updateElement(e, "messages", "response", i)
                            }
                          />

                          <FloatButtons
                            type={"inactivity"}
                            addArtifact={this.handleArtifacts}
                            iteration={i}
                            buttons_toggle_artifacts={[
                              "img",
                              "link",
                              "button",
                              "carousel",
                              "bubble",
                              "for",
                              "reply_button",
                              "video"
                            ]}
                          />
                          {message.lang !== inactivity.default_lang && (
                            <div
                              className={"elements__close"}
                              onClick={(e) =>
                                this.deleteMessage(e, message.lang, i)
                              }
                              role="button"
                              tabIndex={0}
                              onKeyDown={(e) =>
                                this.deleteMessage(e, message.lang, i)
                              }
                            >
                              {closeSvg()}
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div className={"elements__alert"}>
                      <Alert severity="info">
                        <span>
                          {t(
                            "card.content.project.inactivity.messages.no_results"
                          )}
                        </span>
                      </Alert>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Divider />
          <div>
            <div className={"elements__grid"}>
              <div className={"elements__title"}>
                <span>
                  {t("card.content.project.inactivity.intents.title")}
                </span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t(
                      "card.content.project.inactivity.intents.description"
                    ),
                  }}
                ></span>
              </div>
              <div className={"elements_codes"}>
                <Select
                  strSelected={t(
                    "card.content.project.inactivity.intents.select_placeholder"
                  )}
                  placeholder={t(
                    "card.content.project.inactivity.intents.select_placeholder"
                  )}
                  array={selectable_intents}
                  onSelect={this.selectIntentDesk}
                  id={"intents-entities"}
                  type={"intents"}
                  t={t}
                />
              </div>
              <div className={"elements__content"}>
                <div
                  className={`elements__chips ${intents.length > 0 ? "project" : ""
                    }`}
                >
                  {intents.length > 0 || this.state.desk_true.length > 0 ? (
                    <>
                      {this.state.desk_true.map((el, i) => {
                        if (!intents.map((i) => i.id).includes(el.id)) {
                          return (
                            <Chip key={i} label={el.name} variant="outlined" />
                          );
                        }
                      })}
                      {intents.map((el, i) => {
                        return el.desk ? (
                          <Chip key={i} label={el.name} variant="outlined" />
                        ) : (
                          <Chip
                            key={i}
                            label={el.name}
                            onDelete={(e) => this.handleDeleteIntent(e, el, i)}
                            variant="outlined"
                          />
                        );
                      })}
                    </>
                  ) : (
                    <div className={"elements__alert"}>
                      <Alert severity="info">
                        <span>
                          {t(
                            "card.content.project.inactivity.intents.no_results"
                          )}
                        </span>
                      </Alert>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {integrations && integrations.length > 0 && (
            <>
              <Divider />
              <div className={"elements__picker"}>
                <div>
                  <div>
                    <span>
                      {t("card.content.project.inactivity.tickets.title")}
                    </span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t(
                          "card.content.project.inactivity.tickets.description"
                        ),
                      }}
                    ></span>
                  </div>
                </div>
                  <div className={"cen_card intents__content"}>
                    <div className={"content"}>
                      <Integrations
                        zendesk_groups={zendesk_groups}
                        intent={JSON.parse(JSON.stringify(localIntent))} 
                        switchboard={switchboard}
                        integrations={integrations}
                        updateIntent={this.handleIntegrationChange}
                        getGroups={this.getGroups}
                        inactivityMode={true}
                      />
                    </div>
                  </div>
              </div>
                <div className={"elements__picker"}>
                  <div>
                    <div>
                      <span>{t("card.content.project.inactivity.tickets.switch.title")}</span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t(
                            "card.content.project.inactivity.tickets.switch.description"
                          ),
                        }}
                      ></span>
                    </div>
                    <Switch
                      checked={inactivity.desk_tickets}
                      disabled={!inactivity.desk_info?.name}
                      onClick={(e) => {
                        this.updateElement(e, "desk_tickets", "boolean");
                      }}
                      color="primary"
                    />
                  </div>
                </div>
                {inactivity.desk_tickets && (
                  <>
                    <div className={"elements__picker"}>
                      <div>
                        <div>
                          <span>{t("card.content.project.inactivity.tickets.assign.title")}</span>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: t(
                                "card.content.project.inactivity.tickets.assign.description"
                              ),
                            }}
                          ></span>
                        </div>
                        <Switch
                          checked={!!inactivity.desk_assign}
                          onClick={(e) => {
                            this.updateElement(e, "desk_assign", "boolean");
                          }}
                          color="primary"
                        />
                      </div>
                    </div>
                    <div className={"elements__picker"}>
                      <ElementsCustom
                        t={t}
                        type={"inactivity"}
                        input_type={"input_with_tags"}
                        element_type={"desk_tags"}
                        element={inactivity.input || ""}
                        elements={inactivity.desk_tags || []}
                        updateElement={this.handleTags}
                      />
                    </div>
                  </>
                )}
            </>
          )}
        </div>
      </div>
    );
  };

  renderTtlSpecificSection = (ttlType) => {
    const { t } = this.props;
    const ttlKey = "ttl_diff";
    const intentsKey = "intents_ttl_diff";
    const selectableKey = "selectable_intents_ttl_diff";
    const dateKey = "selectedDate_ttl_diff";
    const titleKey = "card.content.project.inactivity.ttl_diff_title";
    const descKey = "card.content.project.inactivity.ttl_diff_description";
    const timeKey = "card.content.project.inactivity.ttl_diff_time";
    const intentsLabelKey = "card.content.project.inactivity.ttl_diff_intents";

    const ttlSpecific = this.state[ttlKey];
    const selectedIntents = this.state[intentsKey];
    const selectableIntents = this.state[selectableKey];
    const selectedDate = this.state[dateKey];
    const isActive = !!ttlSpecific.active;

    return (
      <>
        <Divider />
        <div className={"header"}>
          <div className={"header_content spacing_title"}>
            <div className={"header_title"}>
              <span className={"title"}>{t(titleKey)}</span>
              <span className={"description"}>{t(descKey)}</span>
            </div>
          </div>
        </div>
        <div className={"content"}>
          <div className={"elements__main"}>
            <div className={"elements__picker"}>
              <div>
                <div>
                  <span>{t("card.content.project.inactivity.switch")}</span>
                </div>
                <Switch
                  checked={isActive}
                  onClick={(e) => this.handleToggleTtlSpecificActive(e, ttlType)}
                  color="primary"
                />
              </div>
            </div>
            {isActive && (
              <>
                <Divider />
                <div className={"elements__picker"}>
                  <div>
                    <div>
                      <span>{t(`${timeKey}.title`)}</span>
                      <span dangerouslySetInnerHTML={{ __html: t(`${timeKey}.description`) }}></span>
                    </div>
                    {selectedDate && (
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardTimePicker
                          className={"input-primary"}
                          ampm={false}
                          openTo="minutes"
                          views={["hours", "minutes", "seconds"]}
                          format="HH:mm:ss"
                          value={selectedDate}
                          onChange={(e) => this.handleTimePickerTtlSpecific(e, ttlType)}
                          keyboardIcon={svgClock()}
                        />
                      </MuiPickersUtilsProvider>
                    )}
                  </div>
                </div>
                <Divider />
                <div>
                  <div className={"elements__grid"}>
                    <div className={"elements__title"}>
                      <span>{t(`${intentsLabelKey}.title`)}</span>
                      <span dangerouslySetInnerHTML={{ __html: t(`${intentsLabelKey}.description`) }}></span>
                    </div>
                    <div className={"elements_codes"}>
                      <Select
                        strSelected={t("card.content.project.inactivity.intents.select_placeholder")}
                        placeholder={t("card.content.project.inactivity.intents.select_placeholder")}
                        array={selectableIntents}
                        onSelect={(id) => this.selectIntentDeskTtlSpecific(id, ttlType)}
                        id={`intents-entities-ttl-${ttlType}`}
                        type={"intents"}
                        t={t}
                      />
                    </div>
                    <div className={"elements__content"}>
                      <div className={`elements__chips ${selectedIntents.length > 0 ? "project" : ""}`}>
                        {selectedIntents.length > 0 ? (
                          selectedIntents.map((el, i) => (
                            <Chip
                              key={i}
                              label={el.name}
                              onDelete={(e) => this.handleDeleteIntentTtlSpecific(e, el, i, ttlType)}
                              variant="outlined"
                            />
                          ))
                        ) : (
                          <div className={"elements__alert"}>
                            <Alert severity="info">
                              <span>{t(`${intentsLabelKey}.no_results`)}</span>
                            </Alert>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </>
    );
  };

  render() {
    const {
      inactivity,
      intents,
      selectable_intents_ttl,
      intents_ttl,
      ttl,
      selectedDate_ttl,
    } = this.state;

    const { t } = this.props;
    const disable_ttl = !!ttl.active;
    return inactivity ? (
      inactivity.messages ? (
        <div className={"cen_card"}>
          {this.renderHeader()}
          {this.renderInactivitySection()}
          <Divider />
          <div className={"header"}>
            <div className={"header_content spacing_title"}>
              <div className={"header_title"}>
                <span className={"title"}>
                  {t("card.content.project.inactivity.ttl_title")}
                </span>
                <span className={"description"}>
                  {t("card.content.project.inactivity.ttl_description")}
                </span>
              </div>
            </div>
          </div>
          <div className={"content"}>
            <div className={"elements__main"}>
              <div className={"elements__picker"}>
                <div>
                  <div>
                    <span>{t("card.content.project.inactivity.switch")}</span>
                  </div>
                  <Switch
                    checked={!!ttl.active}
                    onClick={(e) => {
                      this.handleToggleTtlActive(e);
                    }}
                    color="primary"
                  />
                </div>
              </div>
              {disable_ttl && (
                <>
                  <Divider />
                  <div className={"elements__picker"}>
                    <div>
                      <div>
                        <span>{t("card.content.project.inactivity.ttl_time.title")}</span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t("card.content.project.inactivity.ttl_time.description"),
                          }}
                        ></span>
                      </div>
                      {selectedDate_ttl && (
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardTimePicker
                            className={"input-primary"}
                            ampm={false}
                            openTo="minutes"
                            views={["hours", "minutes", "seconds"]}
                            format="HH:mm:ss"
                            value={selectedDate_ttl}
                            onChange={(e) => this.handleTimePickerTtl(e)}
                            keyboardIcon={svgClock()}
                          />
                        </MuiPickersUtilsProvider>
                      )}
                    </div>
                  </div>
                </>
              )}
              {disable_ttl && (
                <>
                  <Divider />
                  <div>
                    <div className={"elements__grid"}>
                      <div className={"elements__title"}>
                        <span>{t("card.content.project.inactivity.ttl_disable.title")}</span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t("card.content.project.inactivity.ttl_disable.description"),
                          }}
                        ></span>
                      </div>
                      <div className={"elements_codes"}>
                        <Select
                          strSelected={t(
                            "card.content.project.inactivity.intents.select_placeholder"
                          )}
                          placeholder={t(
                            "card.content.project.inactivity.intents.select_placeholder"
                          )}
                          array={selectable_intents_ttl}
                          onSelect={this.selectIntentDeskTtl}
                          id={"intents-entities"}
                          type={"intents"}
                          t={t}
                        />
                      </div>
                      <div className={"elements__content"}>
                        <div className={`elements__chips ${intents.length > 0 ? "project" : ""}`}>
                          {intents_ttl.length > 0 || this.state.desk_true.length > 0 ? (
                            <>
                              {this.state.desk_true.map((el, i) => {
                                if (!intents.map((i) => i.id).includes(el.id)) {
                                  return <Chip key={i} label={el.name} variant="outlined" />;
                                }
                              })}
                              {intents_ttl.map((el, i) => {
                                return el.desk ? (
                                  <Chip key={i} label={el.name} variant="outlined" />
                                ) : (
                                  <Chip
                                    key={i}
                                    label={el.name}
                                    onDelete={(e) => this.handleDeleteIntentTtl(e, el, i)}
                                    variant="outlined"
                                  />
                                );
                              })}
                            </>
                          ) : (
                            <div className={'elements__alert'}>
                              <Alert severity="info">
                                <span>
                                  {t("card.content.project.inactivity.intents.no_results")}
                                </span>
                              </Alert>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          {this.renderTtlSpecificSection("diff")}
        </div>
      ) : (
        <div className={"cen_card"}>
          <div className={"content"}>
            <div className="loading">
              <CircularProgress color="primary" size={50} />
            </div>
          </div>
        </div>
      )
    ) : (
      <CardEmpty
        data={this.props.data}
        t={this.props.t}
        type={"inactivity"}
        handleClickLink={this.addInactivity}
        open={false}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state,
  };
};

const connect_chatbot_inactivity = connect(mapStateToProps)(ChatbotInactivity);

export default withTranslation(["common", "languages"])(
  connect_chatbot_inactivity
);
